import { useLanguage } from '@/contexts/LanguageContext';
import { Phone, Mail, MessageCircle, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';

const ContactSection = () => {
  const { t } = useLanguage();

  const items = [
    { icon: Phone, label: t.contact.phone, value: '+43 660 6521071', href: 'tel:+436606521071' },
    { icon: Mail, label: t.contact.email, value: 'office@taxisalzburg.net', href: 'mailto:office@taxisalzburg.net' },
    { icon: MessageCircle, label: t.contact.whatsapp, value: '+43 660 6521071', href: 'https://wa.me/436606521071' },
    { icon: MapPin, label: t.contact.address, value: 'Salzburg, Austria', href: '#' },
  ];

  return (
    <section id="contact" className="py-20 md:py-28 bg-muted">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">{t.contact.title}</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">{t.contact.subtitle}</p>
          <div className="w-16 h-1 bg-gradient-gold mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {items.map((item, i) => (
            <motion.a
              key={i}
              href={item.href}
              target={item.href.startsWith('http') ? '_blank' : undefined}
              rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-card rounded-2xl p-6 text-center shadow-card hover:shadow-gold/20 hover:-translate-y-1 transition-all group"
            >
              <div className="w-14 h-14 rounded-full bg-gradient-gold flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <item.icon className="w-6 h-6 text-primary-foreground" />
              </div>
              <h3 className="font-semibold text-foreground mb-1">{item.label}</h3>
              <p className="text-muted-foreground text-sm" dir="ltr">{item.value}</p>
            </motion.a>
          ))}
        </div>

        <div className="mt-12 max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-card">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d85456.39891735!2d13.0009!3d47.8095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47769acb73b1e0f1%3A0x1c6b8e7e0f9b8e1a!2sSalzburg%2C%20Austria!5e0!3m2!1sen!2s!4v1"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Salzburg Map"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
